import { Dayjs } from "dayjs";

export const COARSE_TIME_LABEL_FORMAT = "HH:mm:ss";

export interface PeriodBoundaryMarker {
  time: Dayjs;
}

export interface ResolvedPeriodBoundary {
  percent: number;
  label: string | undefined;
}

// A boundary outside the visible window still shades correctly (the whole
// window sits on one side of it), but its label is omitted because clamping
// it to the window's edge misrepresents the boundary's actual time.
export const resolvePeriodBoundary = ({
  marker,
  side,
  visibleStart,
  visibleDuration,
}: {
  marker: PeriodBoundaryMarker | undefined;
  side: "before" | "after";
  visibleStart: Dayjs;
  visibleDuration: number;
}): ResolvedPeriodBoundary | undefined => {
  if (!marker) return undefined;
  const raw =
    (marker.time.diff(visibleStart, "second", true) / visibleDuration) * 100;
  if (side === "before" ? raw <= 0 : raw >= 100) return undefined;
  const percent = Math.max(0, Math.min(100, raw));
  return {
    percent,
    label:
      raw === percent
        ? marker.time.utc().format(COARSE_TIME_LABEL_FORMAT)
        : undefined,
  };
};
